export default __webpack_public_path__ + "static/industrial_b.ef155f69fcbeaae4a68fb885bd984af0.svg";